import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/siteData";

export default function AboutSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="flex-1">
            <span className="inline-block px-3 py-1 rounded-full border border-foreground-200 text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-6">
              About Superbuy Spreadsheet
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-[1.15] mb-6">
              The Smart Way To Shop
              <br />
              <span className="text-foreground-400 font-normal italic">From Chinese Sellers</span>
            </h2>
            <p className="text-base text-foreground-600 leading-relaxed mb-8 max-w-lg">
              The Superbuy Spreadsheet is the most comprehensive curated collection of product links for international buyers. We organize thousands of verified listings across sneakers, streetwear, luxury accessories, and everyday essentials. Whether you are a first-time buyer or a seasoned reseller, our spreadsheet saves you hours of research and helps you discover sellers you can trust.
            </p>
            <p className="text-base text-foreground-600 leading-relaxed mb-8 max-w-lg">
              Every link in the Superbuy Spreadsheet is hand-checked and regularly updated. We verify seller ratings, product quality, and shipping reliability so you can shop with confidence. No more digging through forums or Discord channels — everything you need is right here.
            </p>
            <Link
              to="/article/superbuy-spreadsheet-guide"
              className="inline-flex items-center gap-2 text-foreground-900 font-semibold text-sm border-b-2 border-foreground-900 pb-1 hover:text-accent-500 hover:border-accent-500 transition-colors cursor-pointer"
            >
              Read Our Complete Guide
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>

          <div className="flex-1 relative">
            <div className="flex gap-4 items-start">
              <div className="flex flex-col gap-4 pt-8">
                <div className="w-40 h-52 rounded-2xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20photography%20of%20a%20pair%20of%20cream%20colored%20running%20sneakers%20on%20a%20warm%20sand%20textured%20surface%2C%20soft%20diffused%20natural%20daylight%20from%20window%2C%20editorial%20sports%20fashion%20composition%2C%20subtle%20shadows%2C%20high%20detail%20mesh%20and%20sole%20texture%2C%20elegant%20simple%20aesthetic&width=400&height=520&seq=about-new-01-v2&orientation=portrait"
                    alt="Sneakers from Superbuy Spreadsheet"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="w-40 h-40 rounded-2xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Minimalist%20flat%20lay%20of%20a%20woven%20straw%20tote%20bag%20with%20leather%20handles%20on%20a%20light%20cream%20linen%20surface%2C%20soft%20natural%20morning%20light%2C%20clean%20editorial%20accessories%20photography%2C%20warm%20neutral%20tones%2C%20visible%20woven%20texture%20detail%2C%20elegant%20simple%20composition&width=400&height=400&seq=about-new-02-v2&orientation=squarish"
                    alt="Bags from Superbuy Spreadsheet"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <div className="flex flex-col gap-4">
                <div className="w-48 h-64 rounded-2xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Elegant%20product%20photography%20of%20a%20soft%20cashmere%20blend%20sweater%20in%20warm%20taupe%20folded%20on%20a%20cream%20surface%2C%20soft%20natural%20daylight%2C%20minimalist%20editorial%20fashion%20style%2C%20warm%20neutral%20background%2C%20clean%20composition%2C%20visible%20knit%20texture%20detail%2C%20sophisticated%20aesthetic&width=480&height=640&seq=about-new-03-v2&orientation=portrait"
                    alt="Sweater from Superbuy Spreadsheet"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}